<template>
    <div>
        <v-container fluid style="padding:0 15%;">

            <!--设备月度使用时间排名 start-->
            <v-row>
                <v-col
                        cols="6"
                        class="text-left font-weight-bold d-flex align-center">
                    设备月度使用时间排行
                </v-col>
                <v-col
                        cols="6"
                        class="text-right d-flex justify-end align-center">
                    <z-select-month v-model="assetsMonth"
                                    :allowed-dates="allowedDates"
                                    @change="changeAssetsMonth"></z-select-month>
                    <v-btn color="primary" class="ml-4" @click="getAssetsMonthUseTimeReport">报表下载</v-btn>
                </v-col>
            </v-row>
            <div id="staticChart">
            </div>
            <!--设备月度使用时间排名 end-->

            <!--科室月度使用时间排名 start-->
            <v-row>
                <v-col
                        cols="6"
                        class="text-left font-weight-bold d-flex align-center">
                    科室月度使用时间排名
                </v-col>
                <v-col
                        cols="6"
                        class="text-right d-flex justify-end align-center">
                    <z-select-month v-model="deptMonth"
                                    :allowed-dates="allowedDates"
                                    @change="changeDeptMonth"></z-select-month>
                    <v-btn color="primary" class="ml-4" @click="getDeptMonthUseTimeReport">报表下载</v-btn>
                </v-col>
            </v-row>
            <div id="deptChart">
            </div>
            <!--科室月度使用时间排名 end-->

            <!--设备收入vs成本分析 start-->
            <v-row>
                <v-col
                        cols="6"
                        class="text-left font-weight-bold d-flex align-center">
                    设备累计营收(棕叶)
                </v-col>
                <v-col
                        cols="6"
                        class="text-right d-flex justify-end align-center">
                    <v-btn color="primary" class="ml-4" @click="getAssetsIncomeCostAnalysisReport">报表下载</v-btn>
                </v-col>
            </v-row>
            <div id="vsChart">
            </div>
            <!--设备收入vs成本分析 end-->

        </v-container>

        <z-loading v-model="isShowLoading"></z-loading>
    </div>
</template>

<script>
  import ZSelectMonth from "@/components/ZSelectMonth"
  import {
    assetsMonthUseTime,
    deptMonthUseTime,
    assetsIncomeCostAnalysis,
    assetsMonthUseTimeReport,
    deptMonthUseTimeReport,
    assetsIncomeCostAnalysisReport
  } from "@/api/benefitAnalysis"
  import reportDownLoad from "@/utils/reportDownLoad"

  export default {
    name: "BenefitAnalysis",
    data() {
      return {
        assetsMonth: '',
        deptMonth: '',
        isShowLoading: false,
        staticChartInterval:null,
        deptChartInterval:null,
        vsChartInterval:null,
        // 设置三个echart图标最多展示几个
        maxLength:30
      }
    },
    components: {
      ZSelectMonth
    },
    methods: {
      // 设备月度使用时间排行报表下载
      getAssetsMonthUseTimeReport(){
        this.isShowLoading=true;
        var reqData={
          dateMonth:this.assetsMonth
        };
        assetsMonthUseTimeReport(reqData).then(res => {
          this.isShowLoading=false;
          reportDownLoad(res);
        }).catch(err => {
          this.isShowLoading=false;
        });
      },
      // 科室月度使用时间排名报表
      getDeptMonthUseTimeReport(){
        this.isShowLoading=true;
        var reqData={
          dateMonth:this.deptMonth
        };
        deptMonthUseTimeReport(reqData).then(res => {
          reportDownLoad(res);
          this.isShowLoading=false;
        }).catch(err => {
          this.isShowLoading=false;
        });
      },
      // 设备收入vs成本分析报表
      getAssetsIncomeCostAnalysisReport(){
        this.isShowLoading=true;
        assetsIncomeCostAnalysisReport().then(res => {
          reportDownLoad(res);
          this.isShowLoading=false;
        }).catch(err => {
          this.isShowLoading=false;
        });
      },
      getStaticChart() {
        var reqData = {
          dateMonth: this.assetsMonth
        };
        this.isShowLoading = true;
        assetsMonthUseTime(reqData).then(res => {
          this.isShowLoading = false;
          var obj = {
            datax: [],
            datay: []
          };
          for (var i = 0; i < res.length; i++) {
            obj.datax.push(res[i].assetsName);
            obj.datay.push(res[i].monthUseTime);
          }

          if(res.length>this.maxLength){
            var currentObj={
              datax: [],
              datay: [],
            };
            var time=0;
            currentObj={
              datax: obj.datax.slice(time,time+this.maxLength),
              datay: obj.datay.slice(time,time+this.maxLength),
            }
            this.initStaticChart(currentObj);
            clearInterval(this.staticChartInterval);
            this.staticChartInterval=setInterval(() => {
              time++;
              if(time+this.maxLength>res.length){
                time=0;
              }
              currentObj={
                datax: obj.datax.slice(time,time+this.maxLength),
                datay: obj.datay.slice(time,time+this.maxLength),
              };
              this.initStaticChart(currentObj);
            },3000)
          }else{
            this.initStaticChart(obj);
          }
        }).catch(err => {
          this.isShowLoading = false;
        });
      },
      initStaticChart(obj) {
        let lineChartsCharts = this.$echarts.init(document.getElementById('staticChart'))
        lineChartsCharts.resize();
        lineChartsCharts.setOption({
          // title: {
          //   text: '检查总量(人次)',
          //   x: 'center'
          // },
          tooltip: {
            trigger: 'axis',
            itemStyle: {
              normal: {
                label: {
                  show: true
                }
              }
            }
          },
          grid: {
            top: 20,
            left: '5%',
            right: '5%',
          },
          xAxis: {
            type: 'category',
            data: obj.datax,
            axisLabel: {
              interval: 0,
              rotate: -20
            }
          },
          yAxis: {
            type: 'value',
            axisLabel: {
              formatter: ' {value}'
            }
          },
          series: [{
            name: '使用时间',
            type: 'bar',
            barWidth: '5%',
            itemStyle: {
              color: "#0057ff",
              borderColor: "#0057ff",
              // borderWidth: 3,
              shadowColor: 'rgba(0, 0, 0, .3)',
            },
            lineStyle: {
              normal: {
                color: "#0057ff",
                // width: 2
              },
            },
            label: {
              normal: {
                show: true,
                position: 'top',
                color: '#000',
                formatter: function (v) {
                  return v.value + '小时';
                }
              }
            },
            data: obj.datay,
          }]
        })
      },
      getInitDeptChart() {

        var reqData = {
          dateMonth: this.deptMonth
        };
        this.isShowLoading = true;
        deptMonthUseTime(reqData).then(res => {
          this.isShowLoading = false;
          var obj = {
            datax: [],
            datay: []
          };
          for (var i = 0; i < res.length; i++) {
            obj.datax.push(res[i].deptName);
            obj.datay.push(res[i].monthUseTime);
          }
          if(res.length>this.maxLength){
            var currentObj={
              datax: [],
              datay: [],
            };
            var time=0;
            currentObj={
              datax: obj.datax.slice(time,time+this.maxLength),
              datay: obj.datay.slice(time,time+this.maxLength),
            }
            this.initDeptChart(currentObj);
            clearInterval(this.deptChartInterval);
            this.deptChartInterval=setInterval(() => {
              time++;
              if(time+this.maxLength>res.length){
                time=0;
              }
              currentObj={
                datax: obj.datax.slice(time,time+this.maxLength),
                datay: obj.datay.slice(time,time+this.maxLength),
              };
              this.initDeptChart(currentObj);
            },3000)
          }else{
            this.initDeptChart(obj);
          }


        }).catch(err => {
          this.isShowLoading = false;
        });
      },
      initDeptChart(obj) {
        let lineChartsCharts = this.$echarts.init(document.getElementById('deptChart'))
        lineChartsCharts.resize()
        lineChartsCharts.setOption({
          // title: {
          //   text: '检查总量(人次)',
          //   x: 'center'
          // },
          tooltip: {
            trigger: 'axis',
            itemStyle: {
              normal: {
                label: {
                  show: true
                }
              }
            }
          },
          grid: {
            top: 20,
            left: '5%',
            right: '5%',
          },
          xAxis: {
            type: 'category',
            data: obj.datax,
            axisLabel: {
              interval: 0,
              rotate: -20
            }
          },
          yAxis: {
            type: 'value',
            axisLabel: {
              formatter: ' {value}'
            }
          },
          series: [{
            name: '使用时间',
            type: 'bar',
            barWidth: '5%',
            itemStyle: {
              color: "#0057ff",
              borderColor: "#0057ff",
              // borderWidth: 3,
              shadowColor: 'rgba(0, 0, 0, .3)',
            },
            lineStyle: {
              normal: {
                color: "#0057ff",
                // width: 2
              },
            },
            label: {
              normal: {
                show: true,
                position: 'top',
                color: '#000',
                formatter: function (v) {
                  return v.value ;
                }
              }
            },
            data: obj.datay,
          }]
        })
      },
      getInitVsChart() {
        this.isShowDialog = true;
        assetsIncomeCostAnalysis().then(res => {
          this.isShowDialog = false;
          var obj = {
            datax: [],
            // datay: [],
            datay2: []
          };
          for (var i = 0; i < res.length; i++) {
            obj.datax.push(res[i].assetsName);
            // obj.datay.push(res[i].assetsCost);
            obj.datay2.push(res[i].assetsIncome);
          }
          if(res.length>this.maxLength){
            var currentObj={
              datax: [],
              datay: [],
              datay2: []
            };
            var time=0;
            currentObj={
              datax: obj.datax.slice(time,time+this.maxLength),
              // datay: obj.datay.slice(time,time+this.maxLength),
              datay2: obj.datay2.slice(time,time+this.maxLength),
            }
            this.initVsChart(currentObj);
            clearInterval(this.vsChartInterval);
            this.vsChartInterval=setInterval(() => {
              time++;
              if(time+this.maxLength>res.length){
                time=0;
              }
              currentObj={
                datax: obj.datax.slice(time,time+this.maxLength),
                // datay: obj.datay.slice(time,time+this.maxLength),
                datay2: obj.datay2.slice(time,time+this.maxLength),
              };
              this.initVsChart(currentObj);
            },3000)
          }else{
            this.initVsChart(obj);
          }
        }).catch(err => {
          this.isShowDialog = false;
        });

      },
      initVsChart(obj) {
        let lineChartsCharts = this.$echarts.init(document.getElementById('vsChart'));
        lineChartsCharts.resize();
        lineChartsCharts.setOption({
          backgroundColor: 'transparent',
          color: ['RGB(1,255,152)', 'RGB(244,191,70)'],
          animation: false,
          tooltip: {
            trigger: 'axis',
            itemStyle: {
              normal: {
                label: {
                  show: true
                }
              }
            }
          },
          grid: {
            top: "67",
            left: "32",
            bottom: "15",
            right: "39",
            containLabel: true
          },

          xAxis: [{
            type: "category",
            data: obj.datax,
            axisTick: {
              alignWithLabel: true
            },
            nameTextStyle: {
              "color": "red"
            },
            axisLine: {
              "lineStyle": {
                "color": "RGB(47,68,114)"
              }
            },
            axisLabel: {
              interval: 0,
              rotate: -20
              // "textStyle": {
              //   "color": "#333"
              // },
              // margin: 20
            }
          }],
          yAxis: [{
            type: "value",
            axisLabel: {
              // "textStyle": {
              //   "color": "RGB(145,155,183)"
              // },
              // "formatter": "{value}"
            },
            splitLine: {
              // "lineStyle": {
              //   "type": "dashed",
              //   "color": "RGB(47,68,114)"
              // }
            },
            axisLine: {
              // "show": true,
              // "lineStyle": {
              //   "color": "RGB(47,68,114)"
              // }
            }
          }],
          series: [{
            name: '成本',
            type: 'bar',
            //silent: true,
            // "barWidth": "20",
            itemStyle: {
              color: "#FF94A7",
              borderColor: "#FF94A7",
              // borderWidth: 3,
              shadowColor: '#FF94A7',
            },
            //barGap: '-100%', // Make series be overlap
            data: obj.datay
          },
            {
              name: '收入',
              type: 'bar',
              //silent: true,
              // barWidth: "20",
              itemStyle: {
                color: "#59C1F8",
                borderColor: "#59C1F8",
                // borderWidth: 3,
                shadowColor: 'rgba(0, 0, 0, .3)',
              },
              //barGap: '-100%', // Make series be overlap
              data: obj.datay2
            }
          ]
        });
      },
      getCurrentMonth() {
        var date = new Date();
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        if (month < 10) {
          month = '0' + month;
        }
        console.log(year, 'year');
        console.log(month, 'month');
        return year + '-' + month;
      },
      initPage() {
        this.getStaticChart();
        this.getInitDeptChart();
        this.getInitVsChart();
      },
      changeAssetsMonth(month) {
        this.assetsMonth = month;
        this.getStaticChart();
      },
      changeDeptMonth(month) {
        this.deptMonth = month;
        this.getInitDeptChart();
      },
      downLoadReport() {

        // 调接口获取下载链接
        let link = document.createElement('a');
        link.style.display = 'none';
        link.href = '下载链接';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

      },
      allowedDates(val){
        return Date.parse(val)< Date.now()
      },
    },
    mounted() {
      window.onresize = () => {
        return (() => {
          this.initPage();
        })();
      };
      this.assetsMonth = this.getCurrentMonth();
      this.deptMonth = this.getCurrentMonth();
      this.initPage();
    },
    destroyed() {
      window.onresize = null;
      clearInterval(this.staticChartInterval);
      clearInterval(this.deptChartInterval);
      clearInterval(this.vsChartInterval);
    },
    created() {

    }
  }
</script>

<style scoped>
    #staticChart {
        width: 100%;
        height: 40vh;
    }

    #deptChart {
        width: 100%;
        height: 40vh;
    }

    #vsChart {
        width: 100%;
        height: 40vh;
    }
</style>
